import { render, staticRenderFns } from "./static-content-wrapper.vue?vue&type=template&id=251ff38f&scoped=true"
import script from "./static-content-wrapper.vue?vue&type=script&lang=js"
export * from "./static-content-wrapper.vue?vue&type=script&lang=js"
import style0 from "./static-content-wrapper.vue?vue&type=style&index=0&id=251ff38f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ff38f",
  null
  
)

export default component.exports